import {
  Archive,
  Armchair,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUpDown,
  Baby,
  BadgeAlert,
  BadgeDollarSign,
  Ban,
  Banknote,
  Bell,
  Blocks,
  Bold,
  BookOpen,
  BookmarkX,
  BriefcaseBusiness,
  Building,
  BuildingComplex,
  Cake,
  Calculator,
  Calendar,
  CalendarDays,
  Camera,
  Car,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Church,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDollarSign,
  CircleEllipsis,
  CircleMinus,
  CirclePlus,
  CircleQuestionMark,
  CircleSlash,
  CircleUserRound,
  CircleX,
  Clock,
  ClockArrowUp,
  CloudCheck,
  CloudOff,
  Coffee,
  CookingPot,
  Copy,
  CreditCard,
  Database,
  DollarSign,
  Download,
  Drama,
  Earth,
  Egg,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  FilePlus,
  FileSearch,
  FileSpreadsheet,
  FileUp,
  FileX,
  Flag,
  FlaskConical,
  Flower2,
  Funnel,
  Globe,
  Hammer,
  Hand,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  Headset,
  Heart,
  HeartPulse,
  House,
  Image,
  Info,
  Italic,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  LifeBuoy,
  Link,
  List,
  ListChecks,
  ListOrdered,
  ListTodo,
  LogOut,
  Luggage,
  Mail,
  MailCheck,
  MapPin,
  Megaphone,
  Menu,
  Minus,
  Monitor,
  MonitorSmartphone,
  Move,
  OctagonAlert,
  Package,
  PawPrint,
  Pencil,
  PencilLine,
  Percent,
  Plus,
  Receipt,
  ReceiptText,
  Redo2,
  RefreshCw,
  RemoveFormatting,
  Repeat,
  Rocket,
  RotateCcw,
  RotateCcwClock,
  Sailboat,
  Search,
  Send,
  Settings,
  Shapes,
  Share2,
  ShieldUser,
  Shirt,
  SlidersHorizontal,
  Sparkles,
  Sprout,
  SquareCheck,
  SquarePen,
  SquarePlus,
  Store,
  Strikethrough,
  Tag,
  TagPlus,
  ThumbsUp,
  ToyBrick,
  Trash,
  TriangleAlert,
  Truck,
  Underline,
  Undo2,
  Upload,
  UserCog,
  UserPlus,
  Users,
  UsersRound,
  Volleyball,
  Webhook,
  X,
  ShoppingBasket,
  Warehouse,
} from 'lucide';

/**
 * Every icon the app can draw, by Lucide name (https://lucide.dev/icons). To use a new icon,
 * import it from 'lucide' and add it here — only the icons listed are bundled.
 */
const icons = {
  archive: Archive,
  armchair: Armchair,
  'arrow-left': ArrowLeft,
  'arrow-left-right': ArrowLeftRight,
  'arrow-right': ArrowRight,
  'arrow-up-down': ArrowUpDown,
  baby: Baby,
  'badge-alert': BadgeAlert,
  'badge-dollar-sign': BadgeDollarSign,
  ban: Ban,
  banknote: Banknote,
  bell: Bell,
  blocks: Blocks,
  bold: Bold,
  'book-open': BookOpen,
  'bookmark-x': BookmarkX,
  'briefcase-business': BriefcaseBusiness,
  building: Building,
  'building-complex': BuildingComplex,
  cake: Cake,
  calculator: Calculator,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  camera: Camera,
  car: Car,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  church: Church,
  circle: Circle,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-dollar-sign': CircleDollarSign,
  'circle-ellipsis': CircleEllipsis,
  'circle-minus': CircleMinus,
  'circle-plus': CirclePlus,
  'circle-question-mark': CircleQuestionMark,
  'circle-slash': CircleSlash,
  'circle-user-round': CircleUserRound,
  'circle-x': CircleX,
  clock: Clock,
  'clock-arrow-up': ClockArrowUp,
  'cloud-check': CloudCheck,
  'cloud-off': CloudOff,
  coffee: Coffee,
  'cooking-pot': CookingPot,
  copy: Copy,
  'credit-card': CreditCard,
  database: Database,
  'dollar-sign': DollarSign,
  download: Download,
  drama: Drama,
  earth: Earth,
  egg: Egg,
  'ellipsis-vertical': EllipsisVertical,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-off': EyeOff,
  'file-plus': FilePlus,
  'file-search': FileSearch,
  'file-spreadsheet': FileSpreadsheet,
  'file-up': FileUp,
  'file-x': FileX,
  flag: Flag,
  'flask-conical': FlaskConical,
  'flower-2': Flower2,
  funnel: Funnel,
  globe: Globe,
  hammer: Hammer,
  hand: Hand,
  'heading-1': Heading1,
  'heading-2': Heading2,
  'heading-3': Heading3,
  'heading-4': Heading4,
  'heading-5': Heading5,
  'heading-6': Heading6,
  headset: Headset,
  heart: Heart,
  'heart-pulse': HeartPulse,
  house: House,
  image: Image,
  info: Info,
  italic: Italic,
  'key-round': KeyRound,
  'layout-dashboard': LayoutDashboard,
  'layout-grid': LayoutGrid,
  'life-buoy': LifeBuoy,
  link: Link,
  list: List,
  'list-checks': ListChecks,
  'list-ordered': ListOrdered,
  'list-todo': ListTodo,
  'log-out': LogOut,
  luggage: Luggage,
  mail: Mail,
  'mail-check': MailCheck,
  'map-pin': MapPin,
  megaphone: Megaphone,
  menu: Menu,
  minus: Minus,
  monitor: Monitor,
  'monitor-smartphone': MonitorSmartphone,
  move: Move,
  'octagon-alert': OctagonAlert,
  package: Package,
  'paw-print': PawPrint,
  pencil: Pencil,
  'pencil-line': PencilLine,
  percent: Percent,
  plus: Plus,
  receipt: Receipt,
  'receipt-text': ReceiptText,
  'redo-2': Redo2,
  'refresh-cw': RefreshCw,
  'remove-formatting': RemoveFormatting,
  repeat: Repeat,
  rocket: Rocket,
  'rotate-ccw': RotateCcw,
  'rotate-ccw-clock': RotateCcwClock,
  sailboat: Sailboat,
  search: Search,
  send: Send,
  settings: Settings,
  shapes: Shapes,
  'share-2': Share2,
  'shield-user': ShieldUser,
  shirt: Shirt,
  'sliders-horizontal': SlidersHorizontal,
  sparkles: Sparkles,
  sprout: Sprout,
  'square-check': SquareCheck,
  'square-pen': SquarePen,
  'square-plus': SquarePlus,
  store: Store,
  strikethrough: Strikethrough,
  tag: Tag,
  'tag-plus': TagPlus,
  'thumbs-up': ThumbsUp,
  'toy-brick': ToyBrick,
  trash: Trash,
  'triangle-alert': TriangleAlert,
  truck: Truck,
  underline: Underline,
  'undo-2': Undo2,
  upload: Upload,
  'user-cog': UserCog,
  'user-plus': UserPlus,
  users: Users,
  'users-round': UsersRound,
  volleyball: Volleyball,
  webhook: Webhook,
  x: X,
  'shopping-basket': ShoppingBasket,
  warehouse: Warehouse,
};

export type IconName = keyof typeof icons;

export default icons;
